module.exports = __webpack_public_path__ + "static/media/IMG_4253.6d91be48.PNG";